// @flow

export { default } from './Hoverable';
